const LIGHT_COLOR = '#f6f4ef';
const DARK_COLOR = '#0b0b0f';

// Runs before React hydration, without rendering a script tag in the layout.
try {
  const root = document.documentElement;
  const storedMode = localStorage.getItem('mneno-theme') || 'system';
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const mode = storedMode === 'system'
    ? (prefersDark ? 'dark' : 'light')
    : storedMode;
  const theme = mode === 'dark' ? 'dark' : 'light';
  const color = theme === 'dark' ? DARK_COLOR : LIGHT_COLOR;

  root.classList.toggle('dark-mode', theme === 'dark');
  root.style.colorScheme = theme;
  root.style.backgroundColor = color;

  document.getElementById('theme-color')?.setAttribute('content', color);
} catch {
  // Storage and media queries may be unavailable in constrained browsers.
}